import { CbhIcon, DotSeparatedList, Text } from "@clipboard-health/ui-components";
import { Box, ButtonBase, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

import { SHIFT_DISCOVERY_WORKPLACE_OPEN_SHIFTS_MODAL_PATH } from "../paths";
import { useWorkplaceModalsDataContext } from "../useWorkplaceModalsDataContext";

export interface WorkplaceListItemProps {
  workplaceId: string;
  name: string;
  shiftsCount: number;
  formattedDistance: string;
  showDividerAfter?: boolean;
}

export function WorkplaceListItem(props: WorkplaceListItemProps) {
  const { workplaceId, name, shiftsCount, formattedDistance, showDividerAfter = false } = props;

  const history = useHistory();
  const { generateModalPath } = useWorkplaceModalsDataContext();

  return (
    <Box
      sx={{
        pb: showDividerAfter ? 5 : 0,
        borderBottom: "1px solid",
        borderColor: (theme) => (showDividerAfter ? theme.palette.divider : "transparent"),
      }}
    >
      <ButtonBase
        sx={{ textAlign: "left" }}
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.WORKPLACE_OPEN_SHIFTS_OPENED, {
            workplaceId,
            trigger: "Browse All Workplaces",
          });

          history.push(
            generateModalPath(SHIFT_DISCOVERY_WORKPLACE_OPEN_SHIFTS_MODAL_PATH, {
              workplaceId,
            })
          );
        }}
      >
        <Stack direction="row" spacing={2} width="100%">
          <CbhIcon type="map-pin" size="medium" />

          <Stack alignItems="flex-start" width="100%" gap={1}>
            <Text
              variant="body1"
              sx={{
                fontWeight: "medium",
                color: (theme) => theme.palette.text.primary,
                lineHeight: 1.2,
              }}
            >
              {name}
            </Text>

            <Text inline variant="body2" color="text.secondary">
              <DotSeparatedList inline={false}>
                <Text
                  inline
                  semibold
                  variant="caption"
                  color={(theme) => theme.palette.text.secondary}
                >
                  {shiftsCount} open {pluralize("shift", shiftsCount)}
                </Text>

                <Text inline variant="caption" color={(theme) => theme.palette.text.secondary}>
                  {formattedDistance ? `${formattedDistance} away` : undefined}
                </Text>
              </DotSeparatedList>
            </Text>
          </Stack>
        </Stack>
      </ButtonBase>
    </Box>
  );
}
